import { render, staticRenderFns } from "./KLabeledIcon.vue?vue&type=template&id=b6a965ae&scoped=true&"
import script from "./KLabeledIcon.vue?vue&type=script&lang=js&"
export * from "./KLabeledIcon.vue?vue&type=script&lang=js&"
import style0 from "./KLabeledIcon.vue?vue&type=style&index=0&id=b6a965ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a965ae",
  null
  
)

component.options.__file = "KLabeledIcon.vue"
export default component.exports